'use client';

import { useClientConfig } from '@/lib/clients/ClientContext';

/**
 * AI Loading Banner — shown during AI-first flow while waiting for suggestions.
 * Displays spinner + title, plus 2 rows of skeleton tag chips.
 * Matches Figma node 260:12311.
 */
export default function AiAnalyzingState() {
  const clientConfig = useClientConfig();
  return (
    <div className="flex w-full px-[36px] py-[16px] flex-col items-start gap-[12px] bg-brand/10 overflow-hidden">
      {/* Spinner + title row */}
      <div className="flex w-full items-start gap-[12px]">
        {/* Loader icon — smooth rotation */}
        <div className="w-[24px] h-[24px] flex-shrink-0 animate-spin text-brand" style={{ animationDuration: '1s' }}>
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18.7695" cy="19.3014" r="2.20602" transform="rotate(45 18.7695 19.3014)" fill="currentColor" opacity="1" />
            <circle cx="11.6094" cy="22.1601" r="2.20602" transform="rotate(90 11.6094 22.1601)" fill="currentColor" opacity="1" />
            <circle cx="18.957" cy="5.07681" r="2.20602" transform="rotate(45 18.957 5.07681)" fill="currentColor" opacity="0.5" />
            <circle cx="21.8008" cy="12.2343" r="2.20602" transform="rotate(90 21.8008 12.2343)" fill="currentColor" opacity="0.5" />
            <circle cx="4.97852" cy="5.14127" r="2.20602" transform="rotate(45 4.97852 5.14127)" fill="currentColor" opacity="0.25" />
            <circle cx="11.8702" cy="2.39645" r="2.20602" transform="rotate(90 11.8702 2.39645)" fill="currentColor" opacity="0.25" />
            <circle cx="4.92383" cy="18.7448" r="2.20602" transform="rotate(45 4.92383 18.7448)" fill="currentColor" opacity="0.75" />
            <circle cx="2.21293" cy="11.9765" r="2.20602" transform="rotate(90 2.21293 11.9765)" fill="currentColor" opacity="0.75" />
          </svg>
        </div>
        <span className="text-[22px] font-gotham font-bold text-[#101828] leading-[28px]">
          {clientConfig.ui.strings.searchingSuggestions}
        </span>
      </div>

      {/* Skeleton tag chips — 2 rows */}
      <div className="flex w-full flex-col items-start gap-[12px]">
        {/* Row 1 */}
        <div className="flex items-center gap-[12px]">
          <div className="w-[155px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
          <div className="w-[118px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
          <div className="w-[141px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
          <div className="w-[296px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
          <div className="w-[173px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
          <div className="w-[227px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
        </div>
        {/* Row 2 */}
        <div className="flex items-center gap-[12px]">
          <div className="w-[296px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
          <div className="w-[155px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
          <div className="w-[173px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
          <div className="w-[145px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
          <div className="w-[118px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
          <div className="w-[141px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
          <div className="w-[181px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
          <div className="w-[173px] h-[36px] rounded-[8px] bg-[#F8F8F8] shrink-0" />
        </div>
      </div>
    </div>
  );
}
